"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Menu = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _core = require("@emotion/core");
var _react = require("react");
var _reactSelect = require("react-select");
var colors = _interopRequireWildcard(require("../../../constants/colors"));
var _StaticPropContext = require("./StaticPropContext");
/** @jsxRuntime classic */
/** @jsx jsx */

const Menu = _ref => {
  let {
    children,
    ...props
  } = _ref;
  const {
    clientId
  } = (0, _react.useContext)(_StaticPropContext.StaticPropContext);
  return (0, _core.jsx)(_reactSelect.components.Menu, (0, _extends2.default)({}, props, {
    innerProps: {
      ...props.innerProps,
      // Yarg! React-select spreads this object onto the Menu but doesn't allow an arbitrary shape.
      // Let's just push through this since it's a safe thing to do in this case.
      // The Menu component in react-select doesn't do anything weird with this object.
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      "data-client-id": clientId && `${clientId}--menu`
    },
    css: (0, _core.css)`
                margin: 4px 0 4px 0;
                border: 1px solid ${colors.shadowBorder};
                box-shadow: 0 4px 4px -1px ${colors.shadowMenu};
            `
  }), children);
};
exports.Menu = Menu;
//# sourceMappingURL=Menu.js.map